import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    container: {},
    item: {
        flex: 1,
        margin: '0 auto',
        display: 'flex',
        padding: theme.typography.pxToRem(10),
        flexDirection: 'column',
    },
    h1: {
        fontSize: theme.typography.pxToRem(38),
        marginBottom: theme.typography.pxToRem(20),
        fontWeight: 300,
        color: theme.palette.primary.light,
        lineHeight: theme.typography.pxToRem(40),
    },
}));
